export const useBrowserTimezone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone
